import React from 'react';
import { Dropdown, MenuProps } from 'antd';
import { DotsIcon, RefreshClockIcon } from '@/assets/icons/icons';

interface UsersHeaderMenuProps {
  /** Activity entry point is company-admin only per PRD. */
  isCompanyAdmin: boolean;
  onActivity: () => void;
}

const UsersHeaderMenu: React.FC<UsersHeaderMenuProps> = ({
  isCompanyAdmin,
  onActivity,
}) => {
  if (!isCompanyAdmin) return null;

  const items: MenuProps['items'] = [
    {
      key: 'activity',
      label: 'Activity',
      icon: (
        <RefreshClockIcon color='var(--text-primary)' width={14} height={14} />
      ),
      onClick: onActivity,
    },
  ];

  return (
    <Dropdown
      menu={{ items }}
      trigger={['click']}
      placement='bottomRight'
      overlayClassName='settings-users-menu-overlay'
    >
      <span className='users-header-menu-trigger'>
        <DotsIcon color='var(--text-primary)' />
      </span>
    </Dropdown>
  );
};

export default UsersHeaderMenu;
